import { render, staticRenderFns } from "./nationalOverseasManagement.vue?vue&type=template&id=524702b5&scoped=true"
import script from "./nationalOverseasManagement.vue?vue&type=script&lang=js"
export * from "./nationalOverseasManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524702b5",
  null
  
)

export default component.exports